import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas'),(_vm.error)?_c('div',{staticClass:"warning text-center",style:(`width: ${_vm.size}`)},[_vm._v("Error")]):_vm._e(),(_vm.loading)?_c(VProgressCircular,{staticClass:"ma-4",attrs:{"indeterminate":"","color":"primary","size":_vm.size/1.5}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }